// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportObjects = {
	99653: function() {
		return {
			"./intl_segmenter_polyfill_rs_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache0["ug"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache1["XP"](p0i32);
				},
				"__wbindgen_in": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache2["yb"](p0i32,p1i32);
				},
				"__wbindgen_string_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache3["qt"](p0i32,p1i32);
				},
				"__wbindgen_is_object": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache4["uT"](p0i32);
				},
				"__wbindgen_string_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache5["h4"](p0i32,p1i32);
				},
				"__wbg_segments_new": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache6["c3"](p0i32);
				},
				"__wbg_makeiter_508dd15b82dc98f9": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache7["AM"](p0i32);
				},
				"__wbg_new_abda76e883ba8a5f": function() {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache8["a2"]();
				},
				"__wbg_stack_658279fe44541cf6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache9["KM"](p0i32,p1i32);
				},
				"__wbg_error_f851667af71bcfc6": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache10["iX"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache11["m_"](p0i32);
				},
				"__wbindgen_jsval_loose_eq": function(p0i32,p1i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache12["Qr"](p0i32,p1i32);
				},
				"__wbindgen_boolean_get": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache13["HT"](p0i32);
				},
				"__wbindgen_number_get": function(p0i32,p1i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache14["M1"](p0i32,p1i32);
				},
				"__wbindgen_error_new": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache15["hd"](p0i32,p1i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache16["pT"](p0f64);
				},
				"__wbindgen_bigint_from_u64": function(p0i64) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache17["Kx"](p0i64);
				},
				"__wbg_getwithrefkey_15c62c2b8546208d": function(p0i32,p1i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache18["jm"](p0i32,p1i32);
				},
				"__wbg_set_20cbc34131e76824": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache19["Wl"](p0i32,p1i32,p2i32);
				},
				"__wbg_new_b51585de1b234aff": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache20["Tc"]();
				},
				"__wbg_instanceof_ArrayBuffer_39ac22089b74fddb": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache21["W6"](p0i32);
				},
				"__wbg_getPrototypeOf_0953c64f6ba47b38": function(p0i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache22["V7"](p0i32);
				},
				"__wbg_new_0d7da8e129c00c84": function(p0i32,p1i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache23["Sr"](p0i32,p1i32);
				},
				"__wbg_buffer_085ec1f694018c4f": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache24["Zf"](p0i32);
				},
				"__wbg_new_8125e318e6245eed": function(p0i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache25["rU"](p0i32);
				},
				"__wbg_set_5cf90238115182c3": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache26["H6"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_72e2208bbc0efc61": function(p0i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache27["Ky"](p0i32);
				},
				"__wbg_instanceof_Uint8Array_d8d9cb2b8e8ac1d4": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache28["ZT"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache29["fY"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache30["Or"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[23315].exports;
					return wasmImportedFuncCache31["oH"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"309": [
		99653
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"309":{"99653":"0e1ae0710dc97a17b8f0"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};